/**
 * @param {number} preguntasCount
 * @returns {boolean}
 */
export function canFinalizeTest(preguntasCount) {
  return Number(preguntasCount) > 0;
}

/**
 * @param {number} aciertos
 * @param {number} total
 * @returns {number}
 */
export function computeNota(aciertos, total) {
  if (!canFinalizeTest(total)) {
    return 0;
  }
  return (aciertos / total) * 10;
}

/**
 * When a save is already in flight, return the prior outcome instead of starting again.
 * @param {boolean} saveStarted
 * @param {boolean} alreadySaved
 * @returns {boolean | null} true/false if short-circuit, null to proceed
 */
export function resolveInFlightFinalize(saveStarted, alreadySaved) {
  if (!saveStarted) {
    return null;
  }
  return alreadySaved;
}

/**
 * @param {boolean} skipSave
 * @returns {boolean}
 */
export function shouldSkipTestSave(skipSave) {
  return skipSave === true;
}

/**
 * @param {Array<{ respuestasMezcladas: Array<{ esCorrecta?: boolean }> }>} preguntasTest
 * @param {Record<number, number>} respuestasUsuario
 * @returns {number}
 */
export function countAciertos(preguntasTest, respuestasUsuario) {
  let hits = 0;
  preguntasTest.forEach((p, idx) => {
    const respIdx = respuestasUsuario[idx];
    if (respIdx !== undefined && p.respuestasMezcladas[respIdx]?.esCorrecta) {
      hits += 1;
    }
  });
  return hits;
}
